import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import logoImage from '../../img/logo.png'; // Ajuste o caminho se necessário
import { useAuthContext } from '../../context/AuthContext'; // Importar o AuthContext

const AdminLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
   const { adminLogin } = useAuthContext(); // Obter a função de login ESPECÍFICA do admin

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      // Chama a nova função de login do admin no AuthContext.
      const loginData = await adminLogin(email, password);

      if (loginData && loginData.roles?.includes('super_admin')) {
        // Se o login for bem-sucedido e for um super_admin, redireciona para o dashboard admin.
        navigate('/admin/dashboard', { replace: true });
      } else if (loginData?.roles?.some(role=>['support_agent','support_manager'].includes(role))) {
        navigate('/admin/suporte', { replace: true });
      } else {
        // Se o login for bem-sucedido mas não for super_admin, ou se falhar de outra forma.
        setError('Credenciais inválidas ou sem permissão de administrador.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Ocorreu um erro ao tentar fazer login.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <Card style={{ width: '100%', maxWidth: '400px' }}>
        <Card.Body>
          <div className="text-center mb-4">
            <img src={logoImage} alt="Logo" style={{ maxHeight: '100px' }} className="mb-3" />
            <h4>Painel Administrativo</h4>
          </div>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="adminEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" placeholder="Digite seu email de admin" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-3" controlId="adminPassword">
              <Form.Label>Senha</Form.Label>
              <Form.Control type="password" placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </Form.Group>
            <Button variant="primary" type="submit" className="w-100" disabled={isLoading}>
              {isLoading ? <><Spinner as="span" animation="border" size="sm" /> Entrando...</> : 'Entrar'}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AdminLoginPage;